import { useState, useEffect } from 'react';
import { environment } from '../environment';

const POLL_INTERVAL = 2 * 60_000;

export const useVersionCheck = () => {
  const [latestVersion, setLatestVersion] = useState<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        if (!environment.appVersion || !environment.production) {
          return;
        }

        const response = await fetch('/version.json', {
          cache: 'no-store',
          headers: {
            Pragma: 'no-cache',
            'Cache-Control': 'no-cache',
          },
        });

        if (!response.ok) return;

        const data = await response.json();

        if (data.version && data.version !== environment.appVersion) {
          setLatestVersion(data.version);
        }
      } catch (error) {
        console.error('Failed to check version:', error);
      }
    };

    const intervalId = setInterval(checkVersion, POLL_INTERVAL);

    return () => clearInterval(intervalId);
  }, []);

  return { latestVersion };
};
